import { useCallback } from 'react';
import { useSitePreviewData, setSitePreviewData } from '../context/sitePreviewAtoms';
import { useQuerySitesUrl, setQuerySitesResult } from '../context/querySitesContext';
import { useServices } from '../../../context';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../hooks/useBiLogger/biConstants';

export const useViewSite = () => {
  const { isViewLoading } = useSitePreviewData();
  const siteUrl = useQuerySitesUrl();
  const { chatServiceDs } = useServices();
  const biLogger = useBiLogger();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;

  const viewLiveSite = useCallback(async () => {
    try {
      setSitePreviewData({ isViewLoading: true });
      biLogger.actionClicked({ action: ACTION.VIEW_LIVE_SITE, button_name: BUTTON_NAME.VIEW_LIVE_SITE });

      if (siteUrl) {
        window.open(siteUrl, '_blank');
      } else {
        const result = await chatServiceDs.querySites();
        if (result?.url) {
          setQuerySitesResult(result);
          window.open(result.url, '_blank');
        }
      }
    } catch (error) {
      console.error('Failed to fetch site URL:', error);
    } finally {
      setSitePreviewData({ isViewLoading: false });
    }
  }, [siteUrl, chatServiceDs, biLogger]);

  return {
    viewLiveSite,
    isViewLoading,
  };
};
